
import Vue from 'vue';
import BaseButton from '@/components/base/BaseButton.vue';

/**
 * The classic Boards page's introduction to Boards v2, in place of its "Unlock
 * Your Creative Flow" banner for whoever can see v2, and the switch between the
 * two lists. Each list holds only its own boards.
 */
export default Vue.extend({
	name: 'BoardsV2IntroBanner',
	components: {
		BaseButton,
	},
});
